import { getFilenameFromContentDisposition } from "./http";

const BINARY_CONTENT_TYPE = /spreadsheetml|pdf|octet-stream/;
const HTTP_NO_CONTENT = 204;
const CONTENT_TYPE_HEADER = "content-type";
const CONTENT_DISPOSITION_HEADER = "content-disposition";

export type EmptyResponse = Record<string, never>;

export interface BlobDownload {
  readonly blob: Blob;
  readonly filename: string;
}

function parseJsonOrText(raw: string): unknown {
  try {
    return JSON.parse(raw);
  } catch {
    return raw;
  }
}

export async function blobResponseHandler<T>(
  response: Response,
): Promise<Blob | T | EmptyResponse> {
  if (response.status === HTTP_NO_CONTENT) {
    return {};
  }
  const contentType: string = response.headers.get(CONTENT_TYPE_HEADER) ?? "";
  if (response.ok && BINARY_CONTENT_TYPE.test(contentType)) {
    return response.blob();
  }
  const raw: string = await response.text();
  return parseJsonOrText(raw) as T;
}

export async function blobDownloadResponseHandler<T>(
  response: Response,
): Promise<BlobDownload | T | EmptyResponse> {
  const filename: string =
    getFilenameFromContentDisposition(
      response.headers.get(CONTENT_DISPOSITION_HEADER),
    ) ?? "";
  const parsed: Blob | T | EmptyResponse = await blobResponseHandler<T>(
    response,
  );
  if (parsed instanceof Blob) {
    return { blob: parsed, filename };
  }
  return parsed;
}
